/*
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-13 15:08:08
 * @LastEditors: lc
 * @LastEditTime: 2023-08-29 08:42:35
 */
/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout'
const console =
{
  path: '/ad',
  component: Layout,
  hidden: false,
  meta: {
    title: 'banner管理',
    icon: 'zhiwei',
  },
  children: [
    {
      path: 'position',
      name: 'position',
      component: () => import('@/views/console/Ad/Position'),
      meta: {
        title: '广告位管理',
      }
    },
    {
      path: 'banner',
      name: 'banner',
      component: () => import('@/views/console/Ad/Banner'),
      meta: {
        title: '广告管理',
      }
    },
    {
      path: 'area',
      name: 'area',
      component: () => import('@/views/console/villagearea/area'),
      meta: {
        title: '区域管理',
      },
    },
  ]
}
export default console
